<template>
  <Splide
    v-if="raceCardBanners.length"
    :options="options"
    @splide:mounted="onSplideMounted"
    aria-label="Banner Carousel"
    ref="splide"
  >
    <SplideSlide
      v-for="(raceCardBanner, index) in raceCardBanners"
      :key="index"
    >
      <img
        :src="raceCardBanner.attributes.image.data.attributes.url"
        alt="Banner"
        class="slide-img"
      />
    </SplideSlide>
  </Splide>
</template>

<script>
import "@splidejs/splide/dist/css/splide.min.css";
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import { config } from "../../config";

export default {
  name: "RaceCardBanners",

  components: {
    Splide,
    SplideSlide,
  },

  data() {
    return {
      options: {
        type: "loop",
        perPage: 2,
        perMove: 1,
        focus: 0,
        trimSpace: true,
        autoplay: true,
        interval: 8000,
        pauseOnHover: true,
        pauseOnFocus: false,
        pauseOnInteraction: false,
        resetProgress: false,
        arrows: true,
        drag: false,
        pagination: true,
        speed: 1000,
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
        height: "auto",

        breakpoints: {
          1024: {
            perPage: 1,
            drag: true,
          },
        },
      },
    };
  },

  computed: {
    raceCardBanners() {
      return this.$store.getters.getRaceCardBanners;
    },
  },

  methods: {
    onSplideMounted(splide) {
      this.splideInstance = splide;

      this.startAutoplay();
    },

    startAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
      }

      this.autoplayInterval = setInterval(() => {
        if (this.splideInstance) {
          this.splideInstance.go("+1");
        }
      }, 8000);
    },

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    },
  },

  beforeDestroy() {
    this.stopAutoplay();
  },

  mounted() {
    fetch(config.strapiURL)
      .then((response) => response.json())
      .then((data) => {
        this.$store.commit("setRaceCardBanners", data.data);
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error("Error fetching banners:", error);
      });
  },
};
</script>

<style>
.splide {
  width: 100%;
  margin: 0 auto;
  background: #fff;
}

.slide-img {
  width: 100%;
  height: auto;
  max-height: 125px;
  object-fit: fill;
  object-position: center;
  display: block;
  margin: 0 auto;
}

.splide__arrow {
  background: rgba(0, 0, 0, 0.5) !important;
  width: 3em !important;
  height: 3em !important;

  @media screen and (min-width: 1025px) {
    display: none;
  }

  @media screen and (max-width: 640px) {
    width: 1.5rem !important;
    height: 1.5rem !important;
  }
}

.splide__arrow svg {
  fill: #fff !important;
  width: 1.5em !important;
  height: 1.5em !important;
}

.splide__pagination {
  bottom: -1.5em !important;
}

.splide__pagination__page {
  background: #ccc !important;
}

:deep(.splide__pagination__page.is-active) {
  background: #000 !important;
}
</style>
